import {
  DataGridFilter,
  DataGridFilters,
  DataGridOptions,
} from "fe-shared/src/components/DataGrid/modules/types";
import {
  DataGridFiltersParams,
  DataGridRequestParams,
} from "fe-shared-transactions/src/types";
import {
  GridInventoryAdjustment,
  GridInventoryAdjustmentList,
} from "../types/inventoryAdjustments";

export const PROPERTY_NAMES_MAP: { [key: string]: string } = {
  assignee: "assigneeDisplayName",
};

const FILTER_CONVERTERS_MAP: {
  [key: string]: (
    propertyName: string,
    values: string
  ) => DataGridFiltersParams[];
} = {
  adjustmentNumber: (propertyName, values) => [
    {
      propertyName,
      values: values.replace(/[# ]/g, ""),
    },
  ],
};

const getFilterValues = (filter: DataGridFilter): string => {
  switch (filter.type) {
    case "dateRangeFilter": {
      const [startDate, endDate] = filter.value;

      if (startDate) {
        return [startDate, endDate || startDate]
          .map((date) => new Date(date).toJSON())
          .join(",");
      }
      return "";
    }
    case "selectFilter":
      return filter.value.length ? filter.value.join(",") : "";
    default:
      return filter.value.toString();
  }
};

const getPropertyName = (name: string) => PROPERTY_NAMES_MAP[name] || name;

const getFilteringParameters = (filters: DataGridFilters) => {
  const filteringParameters: DataGridFiltersParams[] = [];

  Object.entries(filters).forEach(([property, filter]) => {
    const values = getFilterValues(filter);
    const propertyName = getPropertyName(property);

    if (values) {
      const filterConverter = FILTER_CONVERTERS_MAP[propertyName];
      const newFilteringParameters = filterConverter
        ? filterConverter(propertyName, values)
        : [{ propertyName, values }];

      filteringParameters.push(...newFilteringParameters);
    }
  });

  return filteringParameters;
};

export const getRequestParams = (
  filters: DataGridFilters,
  options: DataGridOptions
): DataGridRequestParams => {
  return {
    filteringParameters: getFilteringParameters(filters),
    sortingBy: {
      propertyName: options.sortField,
      isAscending: options.sortDirection === "asc",
    },
  };
};

export const getFlattenedInventoryAdjustments = (
  data?: GridInventoryAdjustmentList<GridInventoryAdjustment>[]
) =>
  data?.reduce(
    (
      acc: GridInventoryAdjustment[],
      element: GridInventoryAdjustmentList<GridInventoryAdjustment>
    ) => acc.concat(element.overallAdjustments),
    []
  );


export const convertToAdditionOrSubtractionValue = (value?: string, addOrSub? : string) : string | undefined => {
  if(!value || !addOrSub){
    return "";
  }

  switch(addOrSub){
    case ("addition"): 
      return `+${value}`;
    case ("subtraction"): 
      return `-${value}`;
    default:
      return "";
  }
}

export default {
  getRequestParams,
  getFlattenedInventoryAdjustments,
};
